import React, { useState, useEffect } from "react";
import { API, graphqlOperation } from "aws-amplify";
import {
  listCreateOrderOfBillings,
  getCreateOrderOfBilling,
} from "../../graphql/queries";

import { updateZauData } from "../../services/apiZau"
import GenerateOp from "../../http/generateOP-be";

import {
  createCreateOrderOfBilling,
  updateCreateOrderOfBilling,
} from "../../graphql/mutations";
import {
  Card,
  Modal,
  Button,
  Alert,
  Row,
  Col,
  Input,
  notification,
  Descriptions,
  Checkbox,
  Collapse,
  Tag,
  Image,
  Select,
  Table,
  Radio,
  DatePicker,
} from "antd";
import {
  DeleteOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import Swal from "sweetalert2";
import Dropdown from "react-bootstrap/Dropdown";
import fetchItemsNextToken from "../../function/fetchItemsNextTokenZau";
import ZauPayitem from "../../json/payitemZau.json";
import AWS from "aws-sdk";

const { TextArea } = Input;
const { Panel } = Collapse;
const { Option } = Select;
const { Search } = Input;

const user = JSON.parse(localStorage.getItem("profile"));

const {
  REACT_APP_CHECK_OP,
} = process.env;

const s3 = new AWS.S3({
  accessKeyId: process.env.REACT_APP_ACCESS_ID,
  secretAccessKey: process.env.REACT_APP_SECRET_KEY,
  region: "ap-southeast-1",
});

const Admin = (props) => {
  const [listofpermitBilling, setListofpermitBilling] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [viewData, setViewData] = useState(false);
  const [statusEvent, setStatusEvent] = useState(1);
  const [permitId, setPermitId] = useState();
  const [grandTotal, setGrandTotal] = useState("");
  const [opData, setOpData] = useState([]);
  const [values, setValues] = useState({
    lcNo: "",
    applicationNo: "",
    applicationCategory: "",
    projectActivity: "",
    evaluation_facts_extended: "",
    lotNo: "",
    blkNo: "",
    address: "",
    street: "",
    barangay: "",
    district: "",
    owner: "",
    zoneClassification: "",
    occupancy:"",
    lotArea: "",
    floorArea: "",
    noOfUnit: "",
    tctNo: "",
    evaluationOfFacts: "",
  });
  const [zoneClassification, setZoneClassification] = useState([
    "Low Density Residential Zone (R-1)",
    "Low Density Residential SubZone (R-1-A)",
    "Medium Density Residential Zone (R-2)",
    "Medium Density Residential SubZone (R-2-A)",
    "High Density Residential Zone (R-3)",
    "Minor Commercial Zone (C-1)",
    "Major Commercial Zone (C-2)",
    "Metropolitan Commercial Zone (C-3)",
    "Low Intensity Industrial Zone (I-1)",
    "Medium Intensity Industrial Zone (I-2)",
    "Institutional Zone (INST)",
    "Socialized Housing Zone (SHZ)",
    "Transport and Utilities Zone (TRU)",
    "Special Urban Development Zone (SUDZ)",
    "Parks and Recreation Zone (PRZ)",
    "Cemetery (CEM)",
    "Historical Spot and Shrine (HSS)",
    "Environmental Protected Areas (EPA)",
  ]);
  const [listPayitem, setListPayitem] = useState([
    "Zoning - Application (Filling) Fee",
    "Zoning - Certification",
    "Zoning - Commercial",
    "Zoning - Fee",
    "Zoning - Industrial",
    "Zoning - Motion for Reconsideration",
    "Zoning - Others",
    "Zoning - Processing Fee",
    "Zoning - Residential",
    "Zoning - Security Seal",
    "Zoning - Surcharge",
    "Zoning - Verification Fee",
    "Zoning Fees Subdivision",
    "BP 220 Plan Approval",
    "Annual Inspection Fees - CPDO",
    "Locational Clearance of Business",
    "PD 957",
    "Processing Fee: Preliminary Plans",
    "Vertical Component",
  ]);
  const [showmodalRemarks, setShowmodalRemarks] = useState(false);
  const [checkArray, setCheckedArray] = useState([
    {
      paymentitem: "",
      fees: "",
      AccountName: "",
      Accountcode: "",
      OfficeCode: "",
      surcharge: "",
      penalties: "",
      total: "",
    },
  ]);
  const [remarksArray, setRemarksArray] = useState([]);
  const [showModalUpload, setShowModalUpload] = useState(false);
  const [files, setFiles] = useState([]);
  const [uploadFields, setUploadFields] = useState([]);
  const [applicationId, setApplicationId] = useState("");
  const [attachmentId, setAttachmentId] = useState([]);
  const [zoneClassificationMenu, setZoneClassificationMenu] = useState("");
  const [occupancy, setOccupancy] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [checkifhaspayitem, setCheckIfhaspayitem] = useState(false);
  const [tctNo, setctNo] = useState(['']);
  const [appliStatus, setAppliStatus] = useState("");
  const [type, settype] = useState("LC");
  const [evaluationFactions, setevaluationFactions] = useState([
    'PROJECT TYPE IS PERMISSIBLE IN THE ZONE'
  ]);
  const [inputValue, setInputValue] = useState('');
  const [typeofapplication, setTypeofApplication]  = useState("");
  const [counselResolutionDate, setCancelResolutionDate] = useState(null);
  const [occupancy2, setOccupancy2] = useState("");

  useEffect(() => {
    fetchListofPermitLocationClearance();
  }, []);
 

  // fetch application for locational Clearance
  const fetchListofPermitLocationClearance = async (id) => {
    try {
        const queryData = {
        query: listCreateOrderOfBillings,
        variables: {
            filter: {
            isDeleted: { ne: "1" },
            },
            limit: 1000,
        },
        };

        const result_data = await fetchItemsNextToken(queryData);
        console.log(result_data[440]);
        setListofpermitBilling(result_data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)));
        setSearchData(result_data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)));
    } catch (error) {
        console.log(error);
    }
};
  // will Show modal for adding new application
  const handleShowLocationalClearance = () => {
    setIsModalVisible(true);
    setStatusEvent(1);
    setZoneClassificationMenu("")
    setIsChecked(false);
    setCheckIfhaspayitem(false);
    if (checkArray.length === 1) {
      setCheckedArray([...checkArray]);
    } else if (checkArray.length === 0) {
      setCheckedArray([
        ...checkArray,
        {
          paymentitem: "",
          fees: "",
          surcharge: "",
          penalties: "",
          AccountName: "",
          Accountcode: "",
          OfficeCode: "",
          total: "",
        },
      ]);
    }
  };
 
  //cancel modal for adding locational application
  const handleCancelLocationClearance = () => {
    setIsModalVisible(false);
    setOccupancy("");
    setStatusEvent(1);
    setCheckedArray([]);
    setGrandTotal("");
    setctNo(['']);
    setIsChecked(false);
    setCheckIfhaspayitem(false);
    setValues({
      applicationNo: "",
      applicationCategory: "",
      projectActivity: "",
      evaluation_facts_extended: "",
      lotNo: "",
      blkNo: "",
      street: "",
      barangay: "",
      district: "",
      owner: "",
      zoneClassification: "",
      lotArea: "",
      floorArea: "",
      noOfUnit: "",
      tctNo: "",
      evaluationOfFacts: "",
    });
  };
  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues((prev) => {
      return { ...prev, [name]: value };
    });
  };
  
  //function to add locational application
  const handleSubmit = async (e) => {
    e.preventDefault();
    try{
      const result = await API.graphql(
        graphqlOperation(createCreateOrderOfBilling, {
          input: {
            lcNo: values.lcNo,
            application_no: values.applicationNo,
            application_type: "REGULAR",
            typeofapplication:type,
            owner: values.owner,
            occupancy:occupancy,
            project_activity: values.projectActivity,
            evaluation_facts_extended: values.evaluation_facts_extended,
            address: values.address,
            Payitem: JSON.stringify(checkArray),
            isGovementInstitution:isChecked, 
            isNoPaymenItem:checkifhaspayitem,
            opStatus: "0",
            Signature1: "0",
            Signature2: "0",
            status:"1",
            order_payment_no: "0",
            OrNumber: "0",
            OrDate: "0",
            deniedRemarks: JSON.stringify([]),
            deniedDate: JSON.stringify([]),
            grandTotal: grandTotal,
            lot_no: values.lotNo,
            blk_no: values.blkNo,
            location_street: values.street,
            location_barangay: values.barangay,
            location_district: values.district,
            zone_classification: zoneClassificationMenu && zoneClassificationMenu.filter(value => value !== ''),
            lot_area: values.lotArea,
            floor_area: values.floorArea,
            no_of_units: values.noOfUnit,
            tct_no:tctNo,
            billing_officer: user.fname + " " + user.mname + " " + user.lname,
            evaluation_facts: values.evaluationOfFacts,
            ownedBy: props.ownerId,
            division: props.division,
          },
        })
      );
      if (result) {
        Swal.fire(
          'Good job!',
          'Successfully',
          'success'
        ).then(() => {
          setShowmodalRemarks(false);
          setShowModalUpload(false);
          setFiles([]);
          setUploadFields([]);
          setApplicationId("");
          setViewData(false);
          setValues({
            lcNo: "",
            applicationNo: "",
            address: "",
            projectActivity: "",
            applicationCategory: "",
            lotNo: "",
            blkNo: "",
            evaluation_facts_extended: "",
            street: "",
            barangay: "",
            district: "",
            owner: "",
            zoneClassification: "",
            lotArea: "",
            floorArea: "",
            noOfUnit: "",
            tctNo: "",
            evaluationOfFacts: "",
          });
          setPermitId("");
          setGrandTotal("");
          setOpData([]);
          setctNo(['']);
          window.location.reload();
        })
       
      } else {
        notification["error"]({
          message: "error",
          description: "Fail to save your data",
        });
      }

    }catch(error){
      notification["error"]({
        message: "error",
        description: "Fail to save your data",
      });
    }
    
  };

 /* Not Complete(Checked setIsChecked) */
 //Append data to state
 const handleUpdateShow = (e, data) => {
  e.preventDefault();

  if (data?.typeofapplication === "COE") {
    try {
      setIsModalVisible(true);
      setStatusEvent(2);
      setOccupancy(data?.occupancy);
      setOccupancy2(data?.occupancy);
      setApplicationId(data?.id);
      setValues({
        ceNo: data?.ceNo,
        applicationNo: data?.application_no,
        projectActivity: data?.project_activity,
        address: data?.address,
        owner: data?.owner,
        lotArea: data?.lot_area,
        floorArea: data?.floor_area,
        postalAddress: data?.postalAddress,
        counselResolutionNo: data?.counselResolutionNo,
        evaluation_facts_extended: data?.evaluation_facts_extended,
      });
      setCancelResolutionDate(data?.counselResolutionDate);
      setIsChecked(data?.isGovementInstitution);
      setCheckIfhaspayitem(data?.isNoPaymenItem);
      setCheckedArray(JSON.parse(data?.Payitem));
      setGrandTotal(data?.grandTotal);
      settype("COE")
    } catch (error) {
      console.log(error);
    } 
  } else {
    try{
      setIsModalVisible(true);
      setStatusEvent(2);
      setPermitId(data?.id);
      setValues({
        lcNo: data?.lcNo,
        address: data?.address,
        applicationCategory: data?.application_type,
        evaluation_facts_extended: data?.evaluation_facts_extended,
        applicationNo: data?.application_no,
        projectActivity: data?.project_activity,
        lotNo: data?.lot_no,
        blkNo: data?.blk_no,
        street: data?.location_street,
        barangay: data?.location_barangay,
        district: data?.location_district,
        owner: data?.owner,
        lotArea: data?.lot_area,
        floorArea: data?.floor_area,
        noOfUnit: data?.no_of_units,
        tctNo: data?.tct_no,
        evaluationOfFacts: data?.evaluation_facts,
      });
      setOccupancy(data?.occupancy);
      setZoneClassificationMenu(data?.zone_classification.replace(/\[|\]/g, ''));
      isStringParsable(data?.tct_no);
      setAttachmentId(JSON.parse(data?.locations));
      setGrandTotal(data?.grandTotal);
      setIsChecked(data?.isGovementInstitution);
      setCheckIfhaspayitem(data?.isNoPaymenItem);
      setAppliStatus(data?.status);
      settype(data?.typeofapplication);
      if(JSON.parse(data?.Payitem).length === 0) {
        setCheckedArray([
          ...checkArray,
          {
            paymentitem: "",
            fees: "",
            surcharge: "",
            penalties: "",
            AccountName: "",
            Accountcode: "",
            OfficeCode: "",
            total: "",
          },
        ]);
      } else {
        setCheckedArray(JSON.parse(data?.Payitem));
      }
      setTypeofApplication(data?.typeofapplication)
    }catch(error){
      console.log(error)
    }

  }
 
 
}
  
 //check if object is parsable
  const isStringParsable = (str) => {
    try {
      const array = str.split(", ").map((item) => item.replace(/[\[\]]/g, ""));
      setctNo(array);
      return true;
    } catch (error) {
      const array = str.split(", ").map((item) => item.replace("&", ""));
      setctNo(array);
      return false;
    }
  }

  //update locational application
  const handleUpdate = async (e) => {
    e.preventDefault();
    
    try{

      const result = await API.graphql(
        graphqlOperation(updateCreateOrderOfBilling, {
          input: {
            id: permitId,
            lcNo: values.lcNo,
            typeofapplication:type,
            application_no: values.applicationNo,
            application_type: values.applicationCategory,
            owner: values.owner,
            occupancy:occupancy,
            address: values.address,
            project_activity: values.projectActivity,
            lot_no: values.lotNo,
            blk_no: values.blkNo,
            isGovementInstitution:isChecked,
            isNoPaymenItem:checkifhaspayitem,
            location_street: values.street,
            location_barangay: values.barangay,
            location_district: values.district,
            zone_classification: zoneClassificationMenu,
            lot_area: values.lotArea,
            floor_area: values.floorArea,
            no_of_units: values.noOfUnit,
            tct_no: tctNo,
            evaluation_facts: values.evaluationOfFacts,
            evaluation_facts_extended: values.evaluation_facts_extended,
            adminUserName: user.fname + " " + user.mname + " " + user.lname,
            dateAdminUpdate: Date.now(),
            grandTotal: grandTotal,
            Payitem: JSON.stringify(checkArray),
          },
        })
      );
      if (result) {
        notification["success"]({
          message: "Success",
          description: "Updated is inserted",
        });
        setIsModalVisible(false);
        setOccupancy("");
        setStatusEvent(1);
        setCheckedArray([]);
        setGrandTotal("");
        setctNo(['']);
        setIsChecked(false);
        setCheckIfhaspayitem(false);
        setValues({
          applicationNo: "",
          applicationCategory: "",
          projectActivity: "",
          evaluation_facts_extended: "",
          lotNo: "",
          blkNo: "",
          street: "",
          barangay: "",
          district: "",
          owner: "",
          zoneClassification: "",
          lotArea: "",
          floorArea: "",
          noOfUnit: "",
          tctNo: "",
          evaluationOfFacts: "",
        });
        
        fetchListofPermitLocationClearance();
      } else {
        notification["Error"]({
          message: "Error",
          description: "Failed to Updated",
        });
      }

    }catch(error) {
      notification["Error"]({
        message: "Error",
        description: "Failed to Updated",
      });
    }

   
  };

  const handleUpdateCOE = async (e) => {
    e.preventDefault();

    try {
      const result = await API.graphql(
        graphqlOperation(updateCreateOrderOfBilling, {
          input: {
            id: applicationId,
            ceNo: values.ceNo,
            Payitem: JSON.stringify(checkArray),
            typeofapplication: "COE",
            application_no: values.applicationNo,
            application_type: "REGULAR",
            isGovementInstitution: isChecked,
            isNoPaymenItem: checkifhaspayitem,
            owner: values.owner,
            occupancy: occupancy,
            project_activity: values.projectActivity,
            address: values.address,
            grandTotal: grandTotal,
            lot_area: values.lotArea,
            floor_area: values.floorArea,
            postalAddress: values.postalAddress,
            counselResolutionNo: values.counselResolutionNo,
            counselResolutionDate: counselResolutionDate,
            evaluation_facts_extended: values.evaluation_facts_extended,
          },
        })
      );
      if (result) {
        Swal.fire(
          "Data Updated",
          "The data has been successfully updated.",
          "success"
        ).then(() => {
          setValues({
            lcNo: "",
            ceNo: "",
            applicationNo: "",
            applicationCategory: "",
            projectActivity: "",
            evaluation_facts_extended: "",
            lotNo: "",
            blkNo: "",
            address: "",
            street: "",
            barangay: "",
            district: "",
            owner: "",
            zoneClassification: "",
            occupancy: "",
            lotArea: "",
            floorArea: "",
            noOfUnit: "",
            tctNo: "",
            evaluationOfFacts: "",
            postalAddress: "",
            counselResolutionNo: "",
            counselResolutionDate: "",
          });
          setOccupancy("");
          setOccupancy2("");
          setIsModalVisible(false);
          setGrandTotal("");
          setApplicationId("");
          setCheckedArray([]);
        
        });
      }
    } catch (error) {}
  };
 
  //This function get the dropdown
  const handleChangeDropdown = (e, index, name) => {
    let total = 0;
    const values = e.target !== undefined ? e.target.value : e;
    const list = [...checkArray];
    list[index][name] = values;

    if (name !== "fees") {
      list[index]["AccountName"] = ZauPayitem[values]["AccountName"];
      list[index]["Accountcode"] = ZauPayitem[values]["AccountCode"];
      list[index]["OfficeCode"] = ZauPayitem[values]["OfficeCode"];
    }
    
    const a =
      Number(list[index]["fees"]) +
      Number(list[index]["surcharge"]) +
      Number(list[index]["penalties"]);
    list[index]["total"] = a.toFixed(2);
    for (const element of list) {
      total += Number(element["total"]);
    }

    setGrandTotal(total.toFixed(2));
    setCheckedArray(list);
  };
 
  //remove item from array
  const handleRemoveArray = (index) => {
    let total = 0;
    const list = [...checkArray];
    let value = list[index];
    if (!listPayitem.includes(value.paymentitem)) {
      listPayitem.push(value.paymentitem);
    }
    list.splice(index, 1);
    for (let i = 0; i < list.length; i++) {
      total += Number(list[i]["total"]);
    }

    const truncatedAmount = Math.floor(total * 100) / 100;
    const formattedAmount = truncatedAmount.toFixed(2);
    setGrandTotal(formattedAmount);
    setCheckedArray(list);
  };
 
  //add handle dynamic input 
  const handleAddArray = () => {
    const payItemList = checkArray.map((item) => item.paymentitem);
    for (let i = 0; i < payItemList.length; i++) {
      for (let j = 0; j < listPayitem.length; j++) {
        if (payItemList[i] === listPayitem[j]) {
          const a = listPayitem.indexOf(listPayitem[j]);
          console.log(a);
          listPayitem.splice(a, 1);
        }
      }
    }

    setListPayitem(listPayitem);
    setCheckedArray([
      ...checkArray,
      {
        paymentitem: "",
        fees: "",
        surcharge: "",
        penalties: "",
        AccountName: "",
        Accountcode: "",
        OfficeCode: "",
        total: "",
      },
    ]);
  };

  const handlePrintLCForm = (id, typeofapplications = null) => {
    let url;
    let title;
    
    //if typeofapplication is null set to default value lc
    if(!typeofapplications) typeofapplications = "LC";
     
    if(typeofapplications === "COE" || typeofapplications === "coe") url= "/coe-form-print?id=" + id;
    else url = "/lc-form-print?id=" + id;

    title = "Locational Form";
    const params =
      "directories=no,titlebar=no,toolbar=no,location=off," +
      "status=no,menubar=no,scrollbars=no,resizable=no,width=800,height=800";

    window.open(url, title, params);
  };

  const handlePrintOrderOfPayment = (id) => {
    let url;
    let title;
    url = "/orderofpaymentzau-form-print?id=" + id;
    title = "Order of Payment ";
    const params =
      "directories=no,titlebar=no,toolbar=no,location=off," +
      "status=no,menubar=no,scrollbars=no,resizable=no,width=800,height=800";

    window.open(url, title, params);
  };

  async function handleForwardOpstatus(e, data) {
    e.preventDefault();
    try {
      Swal.fire({
        title: `Are you sure want to forward ${data.application_no}?`,
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Forward it!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          // Swal.fire("Forwarded!", "Your file has been Forwarded.", "success");
          try {
            const fetchResult = await API.graphql(
              graphqlOperation(updateCreateOrderOfBilling, {
                input: {
                  id: data.id,
                  opStatus: "1",
                  opStatusDate1: new Date(),
                },
              })
            );
            if (fetchResult) {
              notification["success"]({
                message: "success",
                description: "Successfully forwarded to Division Chief",
              });
              fetchListofPermitLocationClearance();
            }
          } catch (error) {
            console.log(error);
          }
        }
      });
    } catch (error) {
      console.log(error);
    }
  }

  async function viewLocationalClearance(e, data) {
    e.preventDefault();
    try {
      setAttachmentId(JSON.parse(data.locations));
      setViewData(true);
      setCheckedArray(JSON.parse(data.Payitem));
      setOpData(data);
    } catch (error) {
      console.log(error);
    }
  }


  const handleCloseViewData = () => {
    setCheckedArray([]);
    setShowmodalRemarks(false);
    setShowModalUpload(false);
    setFiles([]);
    setUploadFields([]);
    setApplicationId("");
    setViewData(false);
    setValues({
      lcNo: "",
      applicationNo: "",
      address: "",
      projectActivity: "",
      applicationCategory: "",
      lotNo: "",
      blkNo: "",
      evaluation_facts_extended: "",
      street: "",
      barangay: "",
      district: "",
      owner: "",
      zoneClassification: "",
      lotArea: "",
      floorArea: "",
      noOfUnit: "",
      tctNo: "",
      evaluationOfFacts: "",
    });
    setPermitId("");
    setGrandTotal("");
    setOpData([]);

  }

  async function handleCloseshowRemarks() {
    setCheckedArray([]);
    setShowmodalRemarks(false);
    setShowModalUpload(false);
    setFiles([]);
    setUploadFields([]);
    setApplicationId("");
  }

  async function handleRegenerateApplications(e, data) {
    e.preventDefault();
    try {
      Swal.fire({
        title:
          "Do you want to Regenerate it? Kindly put your Remarks. Thank you so much",
        html: `<textarea id="remarks" rows="10" cols="50">`,
        inputAttributes: {
          autocapitalize: "off",
        },
        showCancelButton: true,
        confirmButtonText: "Regenerate",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          const remarks = Swal.getPopup().querySelector("#remarks").value;
          return await API.graphql(
            graphqlOperation(getCreateOrderOfBilling, {
              id: data.id,
            })
          ).then(async (response) => {
            console.log(response);
            return await API.graphql(
              graphqlOperation(updateCreateOrderOfBilling, {
                input: {
                  id: response.data.getCreateOrderOfBilling.id,
                  isDeleted: "1",
                  isDeletedDate: new Date(),
                  whyDeletedRemarks: remarks,
                },
              })
            );
          });
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
        if (result.isConfirmed) {
          notification["success"]({
            message: "success",
            description: "Successfully Approved",
          });
          setIsModalVisible(false);
          fetchListofPermitLocationClearance();
        }
      });
    } catch (error) {
      console.log(error);
    }
  }

  async function handleShowRemarks(e, data) {
    e.preventDefault();
    try {
      setShowmodalRemarks(true);
      setRemarksArray(JSON.parse(data.deniedRemarks));
    } catch (error) {
      console.log("remarks array", error);
    }
  }

  async function handleShowModalUpload(e, data) {
    e.preventDefault();
    try {
      setShowModalUpload(true);
      setApplicationId(data.id);
    } catch (error) {
      console.log(error);
    }
  }

  const handleFileUpload = (event, index) => {
    const newFiles = [...files];
    newFiles[index] = event.target.files[0];
    setFiles(newFiles);
  };

  const handleAddUploadField = () => {
    setUploadFields([...uploadFields, {}]);
    setFiles([...files, null]);
  };

  const handleRemoveUploadField = (index) => {
    const newFields = [...uploadFields];
    newFields.splice(index, 1);
    setUploadFields(newFields);
    const newFiles = [...files];
    newFiles.splice(index, 1);
    setFiles(newFiles);
  };

  const handleUpload = async () => {
    const fileLocations = [];

    try {
      for (const [index, file] of files.entries()) {
        if (file) {
          const params = {
            Bucket: "loigenerators3215254-dev",
            Key: `${Date.now()}_${file.name}`,
            Body: file,
            ACL: "public-read",
          };

          try {
            const data = await s3.upload(params).promise();
            fileLocations[index] = data.Location;
          } catch (error) {
            console.log(error);
          }
        }
      }

      return await API.graphql(
        graphqlOperation(updateCreateOrderOfBilling, {
          input: {
            id: applicationId,
            locations: JSON.stringify(fileLocations),
          },
        })
      ).then((result) => {
        if (result) {
          notification["success"]({
            message: "success",
            description: "Your File is successuflly uploaded",
          });
          fetchListofPermitLocationClearance();
          setShowModalUpload(false);
          setFiles([]);
          setUploadFields([]);
          setApplicationId("");
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  async function handleCheckBillingNumberIfPaid(e, data) {
    e.preventDefault();
    try {


        if (data.order_payment_no) {

          const apiSend = {
            search_value: data.order_payment_no,
          };
          try {
            const fetchResult = await fetch(REACT_APP_CHECK_OP, {
              headers: { "Content-Type": "application/json" },
              method: "POST",
              body: JSON.stringify(apiSend),
            });
            const a = fetchResult.json();
            a.then(async (response) => {
              if (response.data["totalRecords"] === 1) {
                Object.keys(response.data.details).forEach((key) => {
                  if (
                    response.data.details[key].PostFlag === "V" ||
                    response.data.details[key].PostFlag === "C"
                  ) {
                    notification["success"]({
                      message: "success",
                      description:
                        "OR Number is Cancelled! Please verify the transaction at City Treasurer Office",
                    });
                    try {
                      return API.graphql(
                        graphqlOperation(updateCreateOrderOfBilling, {
                          input: {
                            id: data.id,
                            OrNumber: response.data.details[key].ORNumber,
                            OrDate: response.data.details[key].OrDate,
                            isDeleted: "1",
                          },
                        })
                      ).then(async (response) => {
                        if (response) {
                          fetchListofPermitLocationClearance();
                        }
                      });
                    } catch (error) {
                      console.log(error);
                    }
                  } else {
                    return API.graphql(
                      graphqlOperation(updateCreateOrderOfBilling, {
                        input: {
                          id: data.id,
                          OrNumber: response.data.details[key].ORNumber,
                          OrDate: response.data.details[key].OrDate,
                        },
                      })
                    ).then(async (response) => {
                      console.log(response);
                      if (response) {
                        notification["success"]({
                          message: "success",
                          description: `${response.data.updateCreateOrderOfBilling.order_payment_no}`,
                        });
                        fetchListofPermitLocationClearance();
                      }
                    });
                  }
                });
              } else {
                alert("Not Yet Paid");
              }
            });
          } catch (error) {
            console.log(error);
          }
        } else {
          alert("No Order of Payment Number!");
        }
      
    } catch (error) {
      console.log(error);
    }
  }



  const searchdataBilling = (event) => {
    const query = event.toLowerCase(); // convert query to lowercase for case-insensitive search
    const updatedList = listofpermitBilling.filter((item) => {
      const applicantName = item.application_no.toLowerCase();
      const orderPaymentNo = item.owner ? item.owner.toLowerCase() : '';
      return applicantName.includes(query) || orderPaymentNo.includes(query);
    });
    setSearchData(updatedList); 
  };

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
    setCheckedArray([
      {
        paymentitem: "",
        fees: "",
        surcharge: "",
        penalties: "",
        AccountName: "",
        Accountcode: "",
        OfficeCode: "",
        total: "",
      },
    ]);
  setGrandTotal("");
  }

  const handleChangeNoPayitem = (e) => {
    setCheckIfhaspayitem(e.target.checked);
    setCheckedArray([
        {
          paymentitem: "",
          fees: "",
          surcharge: "",
          penalties: "",
          AccountName: "",
          Accountcode: "",
          OfficeCode: "",
          total: "",
        },
      ]);
    setGrandTotal("");
    
  }

  
  const handleInputChange = (index, event) => {
    const newInputs = [...tctNo];
    newInputs[index] = event.target.value;
    setctNo(newInputs);
  };

  const handleAddInput = () => {
    setctNo([...tctNo, '']);
  };

  const handleRemoveInput = (index) => {
    const newInputs = [...tctNo];
    newInputs.splice(index, 1);
    setctNo(newInputs);
  };

  const handleInputChangeEvaluationFact = (value) => {
    console.log(value);
    setInputValue(value);
  }
  
  const handleSearch = (value) => {
    setInputValue(value);
  };

  const handleInputConfirm = () => {
    if (inputValue && !evaluationFactions.includes(inputValue)) {
      setevaluationFactions([...evaluationFactions, inputValue]);
    }
  };
  

const handleGenerateNeWBillingNo = async (e, value) => {
  e.preventDefault();

  var newObject;

  try {
    Swal.fire({
      title: 'Generate New Billing Number?',
      text: 'Are you sure you want to generate a new billing number?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then(async (result) => {
      console.log(value)
      if (result.isConfirmed) {

        const loadingSwal = Swal.fire({
          icon: 'info',
          title: 'Generating Billing Number',
          text: 'Please wait...',
          showConfirmButton: false, // Hide the "OK" button
          allowOutsideClick: false, // Prevent user interaction with the background
        });
          
        if(value.typeofapplication === "COE" || value.typeofapplication === "coe") { 

          const {Payitem, owner, address} = value;

          const PayItemParse = JSON.parse(Payitem);

          newObject = PayItemParse.reduce((result, item, index) => {
            const x = ZauPayitem[item.AccountName || item.paymentitem];
            console.log(x)
            if (x) {
              result.accountname += (index === 0 ? "" : "|||") + x.AccountName;
              result.accountcode += (index === 0 ? "" : "|||") + x.AccountCode;
              result.gender_value += (index === 0 ? "" : "|||") + "1";
              result.rate += (index === 0 ? "" : "|||") + item.total;
              result.quantity += (index === 0 ? "" : "|||") + "1";
              result.requestedby += (index === 0 ? "" : "|||") + "Zoning Administration Unit";
              result.gender_text += (index === 0 ? "" : "|||") + "male";
              result.remarks += (index === 0 ? "" : "|||") + "Payment";
              result.taxpayer_name += (index === 0 ? "" : "|||") + owner.replace(/'|Ñ|ñ/g, "N").replace(/[^a-zA-Z0-9 ]/g, "").toUpperCase();
              result.address += (index === 0 ? "" : "|||") + address.replace(/'|Ñ|ñ/g, "N").replace(/[^a-zA-Z0-9 ]/g, "").toUpperCase()
              
            }
            return result;
          }, {
            accountname: "",
            accountcode: "",
            gender_value: "",
            rate:"",
            quantity:"",
            requestedby:"",
            gender_text:"",
            remarks:"",
            taxpayer_name:"",
            officename: "City Planning and Development Office",
            officecode: "CPDO",
            address:""
          });

          console.log(newObject)

        } else {
            const {Payitem, owner, lot_no, blk_no, location_street, location_barangay, location_district} = value;
          
            try {
              const PayItemParse = JSON.parse(Payitem);
        
              const obAddress =  `${lot_no !== '-' ? "LOT " + lot_no : ''} ${blk_no !== '-' ? "BLK " + blk_no : ''} ${location_street} BRGY. ${location_barangay} ${location_district} QUEZON CITY`;
              newObject = PayItemParse.reduce((result, item, index) => {
                const x = ZauPayitem[item.AccountName || item.paymentitem];
                if (x) {
                  result.accountname += (index === 0 ? "" : "|||") + x.AccountName;
                  result.accountcode += (index === 0 ? "" : "|||") + x.AccountCode;
                  result.gender_value += (index === 0 ? "" : "|||") + "1";
                  result.rate += (index === 0 ? "" : "|||") + item.total;
                  result.quantity += (index === 0 ? "" : "|||") + "1";
                  result.requestedby += (index === 0 ? "" : "|||") + "Zoning Administration Unit";
                  result.gender_text += (index === 0 ? "" : "|||") + "male";
                  result.remarks += (index === 0 ? "" : "|||") + "Payment";
                  result.taxpayer_name += (index === 0 ? "" : "|||") + owner.replace(/'|Ñ|ñ/g, "N").replace(/[^a-zA-Z0-9 ]/g, "").toUpperCase();
                  result.address += (index === 0 ? "" : "|||") + obAddress.replace(/'|Ñ|ñ/g, "N").replace(/[^a-zA-Z0-9 ]/g, "").toUpperCase()
                  
                }
                return result;
              }, {
                accountname: "",
                accountcode: "",
                gender_value: "",
                rate:"",
                quantity:"",
                requestedby:"",
                gender_text:"",
                remarks:"",
                taxpayer_name:"",
                officename: "City Planning and Development Office",
                officecode: "CPDO",
                address:""
              });

            

            } catch (error) {
              // An error occurred during parsing
              console.error("Error parsing JSON:", error);
              // You can handle the error here, e.g., provide a default value or show a message to the user
              // Display a SweetAlert error message
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Something went wrong. Please contact the administrator. Thank you!',
              });
            }
        }
           
      
        try {

  
          const generate_result_op = await GenerateOp.generate_billing_no_for_zau(newObject);
  
          console.log(generate_result_op);
  
          // const generate_result_op = await axios.post(process.env.REACT_APP_GENERATE_OP_ZAU,newObject);
  
          if (!generate_result_op || generate_result_op.data.hasOwnProperty('message')) {
            throw new Error('Something went wrong. Please contact the administrator. Thank you!');
          }
  
          if (generate_result_op.data.status_code === "GC3") {
            throw new Error('TOKEN EXPIRED');
          }
  

          const { bill_number: BillingNo } = generate_result_op.data;
        
          // Simulate a delay (you can replace this with the actual async operation)
          await new Promise(resolve => setTimeout(resolve, 2000));
        
          const result_of_update = await updateZauData(BillingNo, value.id);
          const { order_payment_no } = result_of_update.data.updateCreateOrderOfBilling;
        
          // Close the loading Swal
          loadingSwal.close();
        
          // Show success Swal with the generated billing number
      
          Swal.fire(
            {
              icon: 'success',
              title: `New Billing No: ${order_payment_no}`,
              text: '',
            }).then(() => {
              window.location.reload();
            }
          );
      
          

        } catch (error) {
          // Close the loading Swal in case of an error
          loadingSwal.close();
        
        // Check if the error message is 'TOKEN EXPIRED'
          if (error.message === 'TOKEN EXPIRED') {
            Swal.fire({
              icon: 'error',
              title: 'Token Expired',
              text: 'Failed to generate billing number due to token expired',
            });
          } else {
            // Handle any other errors
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'Failed to generate billing number',
            });
          }
        }
      } else {
        Swal.fire(
          'Billing number generation canceled', 
          '', 
          'info'
          ).then(() => {
            window.location.reload();
          });
      }
    });
    
    
  } catch (error) {
    console.error("Error parsing JSON:", error);
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: 'Something went wrong!',
    });
  }
  
}

  

const handleDateChange = (date) => {
  setCancelResolutionDate(date);
};

const handleCancel = () => {
  setIsModalVisible(false);
  setValues({
    applicationNo: "",
    address: "",
    projectActivity: "",
    applicationCategory: "",
    owner: "",
    lotArea: "",
    floorArea: "",
    postalAddress: "",
    counselResolutionNo: "",
    counselResolutionDate: "",
    ceNo: "",
  });
  setGrandTotal("");
  setStatusEvent(1);
  setOccupancy("");
  setCancelResolutionDate("");
  setCheckedArray([]);
  setStatusEvent(1);
};

const columns = [
  {
    title: "Application No",
    dataIndex: "application_no",
    key: "application_no",
    width: 125,
    align: "center",
    render: (text, record) => (
      <span style={{ fontSize: "16px", fontWeight: "normal" }}>
        {record.application_no}
      </span>
    ),
  },
  {
    title: "Owner",
    dataIndex: "owner",
    key: "owner",
    width: 130,
    align: "center",
    render: (text, record) => (
      <span style={{ fontSize: "16px", fontWeight: "normal" }}>
        {record.owner}
      </span>
    ),
  },
  {
    title: "Project Activity",
    dataIndex: "project_activity",
    key: "project_activity",
    width: 450,
    align: "center",
    render: (text, record) => (
      <span style={{ fontSize: "16px", fontWeight: "normal" }}>
        {record.project_activity}
      </span>
    ),
  },

  {
    title: "Type of Application",
    width: 150,
    align: "center",
    render: (text, record) => (
      <span style={{ fontSize: "16px", fontWeight: "normal" }}>
          {
          record.isGovementInstitution ? (
            <Tag color="#87d068">Goverment</Tag>
          ) :  record.isNoPaymenItem ? (
            <Tag color="#87d068">Amendment</Tag>
          ) : null
        }
      </span>
    ),
  },

  {
    title: "Status",
    width: 150,
    align: "center",
    render: (text, record) => (
      <span style={{ fontSize: "16px", fontWeight: "normal" }}>
          {
          record.status === "1" ? (
            <Tag color="#87d068">New Application</Tag>
          ) :  record.status === "2" ? (
            <Tag color="#87d068">For Recommendation</Tag>
          ) :  record.status === "3" ? (
            <Tag color="#87d068">For Approval</Tag>
          )  : record.status === "4" ? (
            <Tag color="#87d068">For Payment </Tag>
          ) : record.status === "5" ? (
            <Tag color="#87d068">Paid</Tag>
          ) : record.status === "6" ? (
            <Tag color="#87d068">Release</Tag>
          ) :record.status === "15" ? (
            <Button onClick={(e) => handleShowRemarks(e, record)}>
                <Tag color="#f50">Denied</Tag>
            </Button>
          ) : null
        }
      </span>
    ),
  },

  {
    title: "",
    key: "action",
    width: 150,
    align: "center",
    render: (text, record) => (
    
      <div style={{ display: "block" }}>
        <Dropdown>
          <Dropdown.Toggle
            variant="warning"
            id="dropdown-basic"
            style={{ fontWeight: "bold" }}
          >
            Action
          </Dropdown.Toggle>

          <Dropdown.Menu style={{ margin: 0 }}>
            {record.opStatus === "0" && record.opStatus !== "6" && !record.isNoPaymenItem && (
              <Dropdown.Item
                onClick={(e) => handleForwardOpstatus(e, record)}
              >
                Forward
              </Dropdown.Item>
            )}
            {
                (record.status === "4" || record.status === "3") &&
                <Dropdown.Item onClick={(e) => handleGenerateNeWBillingNo(e, record)}>
                  Generate New Billing Number
              </Dropdown.Item>
            }
            

              { (record.status === "1" || record.status === "2" || record.status === "3" || record.status === "5" || record.status === "4" || record.status === "6" || record.status === "15") &&  
              <>
                <Dropdown.Item onClick={(e) => handleUpdateShow(e, record)}>
                  Update
                </Dropdown.Item>
              </>
              }
              
            <Dropdown.Item
              onClick={(e) => viewLocationalClearance(e, record)}
            >
              View
            </Dropdown.Item>

            {/* <Dropdown.Item onClick={(e) => handleGenerateNeWBillingNo(e, record)}>
                  Generate New Billing Number
            </Dropdown.Item> */}
      
          </Dropdown.Menu>
        </Dropdown>

        
          <Dropdown>
            <Dropdown.Toggle
              variant="secondary"
              id="dropdown-basic"
              style={{ fontWeight: "bold", marginTop: "10px" }}
            >
              Upload Files
            </Dropdown.Toggle>
            <Dropdown.Menu style={{ margin: 0 }}>
              <Dropdown.Item
                onClick={(e) => handleShowModalUpload(e, record)}
                target="_blank"
                rel="noreferrer"
              >
                Upload
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        
          {record.status !== "15" && record.status !== "1"  && record.status !== "2"  && record.status !== "3" &&  
          <Dropdown>
            <Dropdown.Toggle
              variant="secondary"
              id="dropdown-basic"
              style={{ fontWeight: "bold", marginTop: "10px" }}
            >
              Print
            </Dropdown.Toggle>

            <Dropdown.Menu style={{ margin: 0 }}>
              <Dropdown.Item
                onClick={() => handlePrintLCForm(record.id, record.typeofapplication)}
                target="_blank"
                rel="noreferrer"
              >
                Locational Clearance
              </Dropdown.Item>
              {record.status !== 
              "6" &&
              !record.isGovementInstitution && !record.isNoPaymenItem && <Dropdown.Item
                onClick={() => handlePrintOrderOfPayment(record.id)}
                target="_blank"
                rel="noreferrer"
              >
                Order of Payment
              </Dropdown.Item>}
              
            </Dropdown.Menu>
          </Dropdown> }
        
          
      
      </div>
    ),
  },
];


  return (
    <div>
        <div className="card" >
          <div className="card-body">
            <div className="alert alert-secondary" role="alert" style={{ marginBottom:"50px" }}>
              <h4><strong>List </strong> of Applications</h4>
            </div>
             <div className="row" >
                 <div className="col-lg-4">
                    <div className="form-group">
                       <Input
                          style={{ width: "100%", marginBottom: "20px", borderRadius: "12px" }}
                          onChange={(e) => searchdataBilling(e.target.value)}
                          placeholder="Search...."
                        />
                    </div>
                 </div>
                 <div className="col-lg-6">
                    <div className="form-group">
                    </div>
                 </div>
                 <div className="col-lg-2">
                    <div className="form-group">
                       <button className="btn btn-block btn-secondary"onClick={handleShowLocationalClearance}  style={{ width: "100%", borderRadius: "12px" }}>
                         Add Application
                       </button>
                    </div>
                 </div>
                 <div className="col-lg-12">
                    <div className="form-group">
                      <Table 
                        bordered
                        columns={columns} 
                        dataSource={searchData} 
                        scroll={{ x: true }}
                       />
                    </div>
                 </div>
             </div>
          </div>
        </div>
       {type !== "COE" ? (
       <> 
       <Modal
          visible={isModalVisible}
          width={1200}
          closable={false}
          footer={[]}
        >
          <Card>
          <Row gutter={[8, 8]} style={{ marginBottom:"10px" }}>
              <Col span={12}>
                <Radio.Group onChange={(e) => settype(e.target.value)}>
                  <Radio value={type === "LC" ? type : "LC"}>LC</Radio>
                  <Radio value={type === "LCSUP" ? type : "LCSUP"}>LC WITH SUP</Radio>
                </Radio.Group>
              </Col>
          </Row>
          <form onSubmit={statusEvent === 1 ? handleSubmit : handleUpdate}>
                        <Row gutter={[8, 8]}>
                            <Col span={12}>
                              <span>
                                <label className="loginInput-label" htmlFor="fname">
                                FOR OSS (ORDER OF PAYMENT)
                                </label>
                                <Select
                                  className="loginInput"
                                  onChange={(e) => setOccupancy(e)}
                                  showSearch
                                  filterOption={(input, option) =>
                                    option.children.includes(input)
                                  }
                                  value={occupancy}
                                >
                                  <Option value="1" >RESIDENTIAL (x3.00)</Option>
                                  <Option value="2" >COMMERCIAL (x10.00)</Option>
                                  <Option value="3" >COMMERCIAL (RENOVATION - x7.5.00)</Option>
                                  <Option value="4" >COE FLR AREA</Option>
                                  <Option value="5" >INSTITUTIONAL (x8.00)</Option>
                                  <Option value="6" >SUP LOT AREA (x150.00)</Option>
                                  <Option value="7" >SUP FLOOR AREA (x150.00)</Option>
                                </Select>
                              </span>
                            </Col>
                        </Row>

                        <Row gutter={[8, 8]}>
                          <Col span={8}>
                          {
                              type === "LC" ? (
                                <span>
                                  <label className="loginInput-label" htmlFor="fname">
                                    LC No.
                                  </label>
                                  <Input
                                    name="lcNo"
                                    value={values.lcNo}
                                    onChange={handleChange}
                                    required
                                  />
                              </span>
                              ) : type === "LCSUP" ? (
                                  <span>
                                    <label className="loginInput-label" htmlFor="fname">
                                      SUP No.
                                    </label>
                                    <Input
                                      name="lcNo"
                                      value={values.lcNo}
                                      onChange={handleChange}
                                      required
                                    />
                                </span>
                              ): <span>
                                    <label className="loginInput-label" htmlFor="fname">
                                      LC No.
                                    </label>
                                    <Input
                                      name="lcNo"
                                      value={values.lcNo}
                                      onChange={handleChange}
                                      required
                                    />
                                  </span>
                            }
                          </Col>
                          <Col span={8}>
                            <span>
                              <label className="loginInput-label" htmlFor="fname">
                                Application No
                              </label>
                              <Input
                                name="applicationNo"
                                value={values.applicationNo}
                                onChange={handleChange}
                                required
                              />
                            </span>
                          </Col>
                          <Col span={8}>
                            <span>
                              <label className="loginInput-label" htmlFor="fname">
                                Owner
                              </label>
                              <Input
                                name="owner"
                                value={values.owner}
                                onChange={handleChange}
                                required
                              />
                            </span>
                          </Col>
                        </Row>

                        <br></br>

                        <Row>
                          <Col span={24}>
                            <span>
                              <label className="loginInput-label" htmlFor="fname">
                                Project Activity:
                              </label>
                              <TextArea
                                rows={2}
                                maxLength={5000}
                                name="projectActivity"
                                value={values.projectActivity}
                                onChange={handleChange}
                                required
                              />
                            </span>
                          </Col>
                        </Row>

                        <Row>
                          <Col span={24}>
    
                          </Col>                   
                        </Row>

                      <br></br>
                        <Row gutter={[8, 8]}>
                          <Col span={12}>
                            <span>
                              <label className="loginInput-label" htmlFor="fname">
                                LOT NO.
                              </label>
                              <Input
                                name="lotNo"
                                value={values.lotNo}
                                onChange={handleChange}
                                required
                              />
                            </span>
                          </Col>
                          <Col span={12}>
                            <span>
                              <label className="loginInput-label" htmlFor="fname">
                                BLK NO.
                              </label>
                              <Input
                                name="blkNo"
                                value={values.blkNo}
                                onChange={handleChange}
                                required
                              />
                            </span>
                          </Col>
                      
                          <Col span={8}>
                            <span>
                              <label className="loginInput-label" htmlFor="fname">
                                STREET.
                              </label>
                              <Input
                                name="street"
                                value={values.street}
                                onChange={handleChange}
                                required
                              />
                            </span>
                          </Col>

                          <Col span={8}>
                            <span>
                              <label className="loginInput-label" htmlFor="fname">
                                Baranggay.
                              </label>
                              <Input
                                name="barangay"
                                value={values.barangay}
                                onChange={handleChange}
                                required
                              />
                            </span>
                          </Col>

                          <Col span={8}>
                            <span>
                              <label className="loginInput-label" htmlFor="fname">
                                District.
                              </label>
                              <Input
                                name="district"
                                value={values.district}
                                onChange={handleChange}
                                required
                              />
                            </span>
                          </Col>
                        </Row>

                      <br></br>

                        <Row gutter={[40, 40]}>

                          <Col span={24}>
                            <span>
                              <label className="loginInput-label" htmlFor="fname">
                                Zone Classification
                              </label>
                              <Select
                                mode="multiple"
                                className="loginInput"
                                onChange={(e) => setZoneClassificationMenu(e)}
                                showSearch
                                filterOption={(input, option) =>
                                  option.children.includes(input)
                                }
                                value={zoneClassificationMenu}
                              >
                                {zoneClassification?.map((item, i) => (
                                  <Option value={item} key={item}>
                                    {item}
                                  </Option>
                                ))}
                              </Select>
                            </span>
                          </Col>

                          <Col span={12}>
                            <span>
                              <label className="loginInput-label" htmlFor="fname">
                                Lot Area sq.m
                              </label>
                              <Input
                                type="number"
                                name="lotArea"
                                step={null}
                                value={values.lotArea}
                                onChange={handleChange}
                                required
                              />
                            </span>
                          </Col>

                          <Col span={12}>
                            <span>
                              <label className="loginInput-label" htmlFor="fname">
                                Floor Area sq.m
                              </label>
                              <Input
                                type="number" 
                                name="floorArea"
                                step={null}
                                value={values.floorArea}
                                onChange={handleChange}
                                required
                              />
                            </span>
                          </Col>

                          <Col span={12}>
                            <span>
                              <label className="loginInput-label" htmlFor="fname">
                                No of Unit.
                              </label>
                              <Input
                                name="noOfUnit"
                                value={values.noOfUnit}
                                onChange={handleChange}
                                required
                              />
                            </span>
                          </Col>

                          <Col span={12}>
                          <span> 
                            {tctNo.map((value, index) => (
                            <div key={value}>
                              <label className="loginInput-label" htmlFor="fname">
                                Tct No:
                              </label>
                              <Input
                                value={value}
                                onChange={(event) => handleInputChange(index, event)}
                              />

                              {index === tctNo.length - 1 && (
                                <Button onClick={handleAddInput} style={{ marginTop:"10px" }}>Add Input</Button>
                              )}

                              {index !== tctNo.length - 1 && (
                                <Button onClick={() => handleRemoveInput(index)}style={{ marginTop:"10px" }} >Remove</Button>
                              )}
                            </div>
                          ))}</span>
                          </Col>
                          

                          <Col span={24}>
                            <span>
                              <label className="loginInput-label" htmlFor="fname">
                                  Evaluation of Facts
                              </label>
                              <Select
                                showSearch
                                allowClear
                                placeholder="Select or input"
                                className="loginInput"
                                onSearch={handleSearch}
                                onChange={handleInputChangeEvaluationFact}
                                onBlur={handleInputConfirm}
                                value={inputValue}
                                filterOption={false}
                              >
                                {evaluationFactions.map((option) => (
                                  <Option key={option} value={option}>
                                    {option}
                                  </Option>
                                ))}
                              </Select>
                            </span>
                          </Col>

                          <Col span={24}>
                            <span>
                              <label className="loginInput-label" htmlFor="fname">
                              Prescriptive Notation:
                              </label>
                              <TextArea
                                rows={2}
                                maxLength={5000}
                                value={values.evaluation_facts_extended}
                                name="evaluation_facts_extended"
                                onChange={handleChange}
                              />
                            </span>
                          </Col>

                        </Row>

                      <br></br>

                      <Row>
                        <Checkbox checked={isChecked} onChange={handleCheckboxChange}  disabled={appliStatus === "6" ? true : false}> Is this an application for government institution?
                        </Checkbox>
                      </Row>
                      <Row>
                        <Checkbox checked={checkifhaspayitem} onChange={handleChangeNoPayitem} disabled={(appliStatus === "6") ? true : false}> Is this an application for Amendment?
                        </Checkbox>
                      </Row>

                      <br></br>

                      {!isChecked && !checkifhaspayitem &&
                        <>
                          <Card>
                            <div className="row">
                              <div className="col-lg-12">
                                <div className="table-responsive">
                                  {" "}
                                  <table className="table table-bordered">
                                    <thead>
                                      <tr>
                                        <th className="text-center"> Pay Item</th>
                                        <th className="text-center"> Fees </th>
                                        <th className="text-center"> Total </th>
                                        <th />
                                        <th />
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {checkArray?.map((item, idx) => (
                                        <tr id="addr0" key={item}>
                                          <td>
                                            <Select
                                              style={{
                                                width: 310,
                                                marginRight: 10,
                                                marginLeft: 10,
                                                marginBottom: 20,
                                              }}
                                              placeholder="Pay Item"
                                              onChange={(e) =>
                                                handleChangeDropdown(e, idx, "paymentitem")
                                              }
                                              showSearch
                                              filterOption={(input, option) =>
                                                option.children.includes(input)
                                              }
                                              filterSort={(optionA, optionB) =>
                                                optionA.children
                                                  .toLowerCase()
                                                  .localeCompare(
                                                    optionB.children.toLowerCase()
                                                  )
                                              }
                                              value={checkArray[idx]["paymentitem"]}
                                            >
                                              {listPayitem?.map((item, i) => (
                                                <Option value={item} key={item}>
                                                  {item}
                                                </Option>
                                              ))}
                                            </Select>
                                          </td>
                                          <td>
                                            <Input
                                              className="form-control"
                                              onChange={(e) =>
                                                handleChangeDropdown(e, idx, "fees")
                                              }
                                              value={checkArray[idx]["fees"]}
                                            />
                                          </td>

                                          <td>
                                            <Input
                                              className="form-control"
                                              placeholder="Total"
                                              value={checkArray[idx]["total"]}
                                              readOnly
                                            />
                                          </td>
                                          <td>
                                            {checkArray.length !== 1 && (
                                              <Button
                                                onClick={() => handleRemoveArray(idx)}
                                              >
                                                <DeleteOutlined
                                                  style={{
                                                    marginRight: "10px",
                                                    marginTop: "4px",
                                                    cursor: "pointer",
                                                  }}
                                                />
                                                Remove
                                              </Button>
                                            )}
                                          </td>
                                          <td>
                                            {checkArray.length - 1 === idx && (
                                              <Button
                                                onClick={handleAddArray}
                                                disabled={
                                                  checkArray.length < 19 ? false : true
                                                }
                                              >
                                                <PlusOutlined
                                                  style={{
                                                    marginTop: "4px",
                                                    cursor: "pointer",
                                                  }}
                                                />
                                                Add
                                              </Button>
                                            )}
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                                <div className="row">
                                  <div className="col-lg-4"> </div>
                                  <div className="col-lg-4">
                                    <label className="loginInput-label" htmlFor="fname">
                                      GrandTotal:
                                    </label>
                                    <Input
                                      step="any"
                                      type="number"
                                      value={grandTotal}
                                      readOnly
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Card>
                        </>
                      }
                      
                      <>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginTop: "20px",
                          }}
                        >
                          <span>
                            <Button onClick={handleCancelLocationClearance} danger>
                              Close
                            </Button>
                          </span>
                          {statusEvent === 1 ? (
                            <span>
                              <button type="submit" className="btn btn-success btn-sm">
                                Save Permit Location Clearance
                              </button>
                            </span>
                          ) : statusEvent === 2 ? (
                            <span>
                              <button type="submit" className="btn btn-success btn-sm">
                                Update Permit Location Clearance
                              </button>
                            </span>
                          ) : null}
                        </div>
                      </>
                    </form>
                </Card>
                </Modal> </>
                ) :type === "COE" ? (
                <> 
          <Modal visible={isModalVisible} closable={false} width={1000} footer={[]}>
              <Card>
                <form
                  onSubmit={
                    statusEvent === 1
                      ? (e) => handleSubmit(e)
                      : (e) => handleUpdateCOE(e)
                  }
                >
                  
                  <Row gutter={[8, 8]}>
                    <Col span={24}>
                      <span>
                        <label className="loginInput-label" htmlFor="fname">
                          Application No
                        </label>
                        <Input
                          name="applicationNo"
                          value={values.applicationNo}
                          onChange={handleChange}
                          required
                        />
                      </span>
                    </Col>
                  </Row>
                  <Row gutter={[8, 8]}>
                    <Col span={24}>
                      <span>
                        <label className="loginInput-label" htmlFor="fname">
                          CE No.
                        </label>
                        <Input
                          name="ceNo"
                          value={values.ceNo}
                          onChange={handleChange}
                          required
                        />
                      </span>
                    </Col>
                  </Row>
                  <Row gutter={[8, 8]}>
                    <Col span={24}>
                      <span>
                        <label className="loginInput-label" htmlFor="fname">
                          Project Activity
                        </label>
                        <Input
                          name="projectActivity"
                          value={values.projectActivity}
                          onChange={handleChange}
                          required
                        />
                      </span>
                    </Col>
                  </Row>
                  <Row gutter={[8, 8]}>
                    <Col span={24}>
                      <span>
                        <label className="loginInput-label" htmlFor="fname">
                          Owner
                        </label>
                        <Input
                          name="owner"
                          value={values.owner}
                          onChange={handleChange}
                          required
                        />
                      </span>
                    </Col>
                  </Row>
                  <Row gutter={[8, 8]}>
                    <Col span={24}>
                      <span>
                        <label className="loginInput-label" htmlFor="fname">
                          Location
                        </label>
                        <Input
                          name="address"
                          value={values.address}
                          onChange={handleChange}
                          required
                        />
                      </span>
                    </Col>
                  </Row>
                  <Row gutter={[8, 8]}>
                    <Col span={24}>
                      <span>
                        <label className="loginInput-label" htmlFor="fname">
                          Lot Area(sq.m)
                        </label>
                        <Input
                          name="lotArea"
                          type="number"
                          value={values.lotArea}
                          onChange={handleChange}
                          required
                        />
                      </span>
                    </Col>
                    <Col span={24}>
                      <span>
                        <label className="loginInput-label" htmlFor="fname">
                          Floor Area(sq.m)
                        </label>
                        <Input
                          name="floorArea"
                          type="number"
                          value={values.floorArea}
                          onChange={handleChange}
                          required
                        />
                      </span>
                    </Col>
                  </Row>
                  <Row gutter={[8, 8]}>
                    <Col span={24}>
                      <span>
                        <label className="loginInput-label" htmlFor="fname">
                          Postal Address
                        </label>
                        <Input
                          name="postalAddress"
                          value={values.postalAddress}
                          onChange={handleChange}
                          required
                        />
                      </span>
                    </Col>
                  </Row>
                  <Row gutter={[8, 8]}>
                    <Col span={24}>
                      <span>
                        <label className="loginInput-label" htmlFor="fname">
                          Prescriptive Notation:
                        </label>
                        <TextArea
                          rows={2}
                          maxLength={5000}
                          value={values.evaluation_facts_extended}
                          name="evaluation_facts_extended"
                          onChange={handleChange}
                        />
                      </span>
                    </Col>
                  </Row>
                  <Row gutter={[8, 8]}>
                    <Col span={24}>
                      <span>
                        <label className="loginInput-label" htmlFor="fname">
                          Council Resolution No.
                        </label>
                        <Input
                          name="counselResolutionNo"
                          value={values.counselResolutionNo}
                          onChange={handleChange}
                          required
                        />
                      </span>
                    </Col>
                  </Row>
                  <Row gutter={[8, 8]}>
                    <Col span={24}>
                      <span>
                        <label
                          className="loginInput-label"
                          htmlFor="fname"
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          Council Resolution Date.
                        </label>
                        <DatePicker onChange={handleDateChange} />
                      </span>
                    </Col>
                  </Row>

                  <br></br>
                  <Card>
                    <Row>
                      <Checkbox checked={isChecked} onChange={handleCheckboxChange}>
                        {" "}
                        Is this an application for government institution?
                      </Checkbox>
                    </Row>
                    <Row>
                      <Checkbox
                        checked={checkifhaspayitem}
                        onChange={handleChangeNoPayitem}
                      >
                        {" "}
                        Is this an application for Amendment?
                      </Checkbox>
                    </Row>
                  </Card>
                  <br></br>
                  {!isChecked && !checkifhaspayitem && (
                    <Card>
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="table-responsive">
                            {" "}
                            <table className="table table-bordered">
                              <thead>
                                <tr>
                                  <th className="text-center"> Pay Item</th>
                                  <th className="text-center"> Fees </th>
                                  <th className="text-center"> Total </th>
                                  <th />
                                  <th />
                                </tr>
                              </thead>
                              <tbody>
                                {checkArray?.map((item, idx) => (
                                  <tr id="addr0" key={item}>
                                    <td>
                                      <Select
                                        style={{
                                          width: 310,
                                          marginRight: 10,
                                          marginLeft: 10,
                                          marginBottom: 20,
                                        }}
                                        placeholder="Pay Item"
                                        onChange={(e) =>
                                          handleChangeDropdown(e, idx, "paymentitem")
                                        }
                                        showSearch
                                        filterOption={(input, option) =>
                                          option.children.includes(input)
                                        }
                                        filterSort={(optionA, optionB) =>
                                          optionA.children
                                            .toLowerCase()
                                            .localeCompare(
                                              optionB.children.toLowerCase()
                                            )
                                        }
                                        value={checkArray[idx]["paymentitem"]}
                                      >
                                        {listPayitem?.map((item, i) => (
                                          <Option value={item} key={item}>
                                            {item}
                                          </Option>
                                        ))}
                                      </Select>
                                    </td>
                                    <td>
                                      <Input
                                        className="form-control"
                                        onChange={(e) =>
                                          handleChangeDropdown(e, idx, "fees")
                                        }
                                        value={checkArray[idx]["fees"]}
                                      />
                                    </td>

                                    <td>
                                      <Input
                                        className="form-control"
                                        placeholder="Total"
                                        value={checkArray[idx]["total"]}
                                        readOnly
                                      />
                                    </td>
                                    <td>
                                      {checkArray.length !== 1 && (
                                        <Button
                                          onClick={() => handleRemoveArray(idx)}
                                        >
                                          <DeleteOutlined
                                            style={{
                                              marginRight: "10px",
                                              marginTop: "4px",
                                              cursor: "pointer",
                                            }}
                                          />
                                          Remove
                                        </Button>
                                      )}
                                    </td>
                                    <td>
                                      {checkArray.length - 1 === idx && (
                                        <Button
                                          onClick={handleAddArray}
                                          disabled={
                                            checkArray.length < 19 ? false : true
                                          }
                                        >
                                          <PlusOutlined
                                            style={{
                                              marginTop: "4px",
                                              cursor: "pointer",
                                            }}
                                          />
                                          Add
                                        </Button>
                                      )}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                          <div className="row">
                            <div className="col-lg-4"> </div>
                            <div className="col-lg-4">
                              <label className="loginInput-label" htmlFor="fname">
                                GrandTotal:
                              </label>
                              <Input
                                step="any"
                                type="number"
                                value={grandTotal}
                                readOnly
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </Card>
                  )}

                  <br></br>
                  <Row
                    gutter={[24, 24]}
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Col span={4}>
                      <button
                        type="button"
                        className="btn btn-danger"
                        onClick={handleCancel}
                      >
                        Close
                      </button>
                    </Col>
                    <Col span={4}>
                      {statusEvent === 1 ? (
                        <span>
                          <button type="submit" className="btn btn-primary">
                            Submit
                          </button>
                        </span>
                      ) : statusEvent === 2 ? (
                        <span>
                          <button type="submit" className="btn btn-success">
                            Update
                          </button>
                        </span>
                      ) : null}
                    </Col>
                  </Row>
                </form>
              </Card>
      </Modal>
      </>
      ) : null
    }
       

 
              
       
                <Modal
                  visible={viewData}
                  width={1200}
                  closable={false}
                  footer={[
                    <>
                      <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <Button onClick={handleCloseViewData} danger>
                          Close
                        </Button>
                      </div>
                    </>,
                  ]}
                >
                  <Row>
                    <Col xs={24} xl={24}>
                      <Card
                      title={
                        !opData?.isGovementInstitution && !opData?.isNoPaymenItem ? (
                          <Alert
                          style={{ fontWeight: "bold", fontSize: "16px" }}
                          message={`Billing Number: ${
                            opData.order_payment_no !== "0"
                              ? opData.order_payment_no
                              : "Not Yet Approved"
                          }`}
                          type="info"
                        />
                        ):null
                      }
                      >
                      {opData?.isGovementInstitution &&  
                        <Card>
                          This application is for goverment Institution
                        </Card>
                        }

                      {opData?.isNoPaymenItem &&  
                        <Card>
                          This application is for Ammendment
                        </Card>
                        }
                        
                        <br></br>
                        <Collapse size="large">
                          <Panel header="Locational Details" key="1">
                            <Descriptions layout="vertical" size="middle" bordered>
                              <Descriptions.Item label="Name of Applicant">
                                <b>
                                  {opData && String(opData.owner).toLocaleUpperCase()}
                                </b>
                              </Descriptions.Item>
                              <Descriptions.Item label="Project Activity">
                                <b>
                                  {opData &&
                                    String(opData.project_activity).toUpperCase()}
                                </b>
                              </Descriptions.Item>
                              <Descriptions.Item label="Project Location">
                                <b>{opData && `${opData.lot_no}, ${opData.blk_no}, ${opData.location_street}, ${opData.location_barangay}, ${opData.location_district}, QUEZON CITY`}</b>
                              </Descriptions.Item>
                              <Descriptions.Item label="Floor Area (sq.m)">
                                <b>
                                  {opData && String(opData.floor_area).toUpperCase()}
                                </b>
                              </Descriptions.Item>
                              <Descriptions.Item label="Lot Area (sq.m)">
                                <b>{opData && String(opData.lot_area).toUpperCase()}</b>
                              </Descriptions.Item>
                              <Descriptions.Item label="Application No">
                                <b>
                                  {opData &&
                                    String(opData.application_no).toUpperCase()}
                                </b>
                              </Descriptions.Item>
                              <Descriptions.Item label="District">
                                <b>
                                  {opData &&
                                    String(opData.location_district).toUpperCase()}
                                </b>
                              </Descriptions.Item>

                              <Descriptions.Item label="Zone Classifications">
                                <b>
                                  {String(opData.zone_classification).replace(/\[|\]/g, '')}
                                </b>
                              </Descriptions.Item>
                              <Descriptions.Item label="Evaluation of Facts:">
                                <b>
                                  {opData &&
                                    String(opData.evaluation_facts).toUpperCase()}
                                </b>
                              </Descriptions.Item>
                            </Descriptions>
                          </Panel>
                          { !opData?.isGovementInstitution && !opData?.isNoPaymenItem &&
                                  <Panel header="Order of Payment Details" key="2">
                                  <Card type="inner" style={{ marginTop: "10px" }}>
                                    <Row gutter={[8, 16]}>
                                      <table className="table-responsive">
                                        <table className="table table-bordered">
                                          <thead>
                                            <tr>
                                              <th scope="col">Payitem</th>
                                              <th scope="col">FEES</th>
                                              <th scope="col">TOTAL</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {checkArray?.map((x, i) => (
                                              <tr>
                                                <td>{checkArray[i]["paymentitem"]}</td>
                                                <td>{checkArray[i]["fees"]}</td>
                                                <td>{checkArray[i]["total"]}</td>
                                              </tr>
                                            ))}
                                          </tbody>
                                        </table>
                                      </table>
                                    </Row>
                                  </Card>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "end",
                                      marginTop: "30px",
                                    }}
                                  >
                                    <Row gutter={[8, 24]}>
                                      <Col span={24}>
                                        <span>
                                          <label className="loginInput-label" htmlFor="fname">
                                            GRAND TOTAL:
                                          </label>
                                          <Input
                                            style={{
                                              fontWeight: "bold",
                                              fontSize: "20px",
                                              width: "80%",
                                              display: "flex",
                                              justifyContent: "",
                                            }}
                                            value={`Php ${opData.grandTotal}`}
                                          />
                                        </span>
                                      </Col>
                                    </Row>
                                  </div>
                                </Panel>
                          }
                    
                          <Panel header="Attachment" key="3">
                            {" "}
                            <Card type="inner" style={{ marginTop: "10px" }}>
                              <Row gutter={[8, 16]}>
                                <table className="table-responsive">
                                  <table className="table table-bordered">
                                    <thead>
                                      <tr>
                                        <th scope="col">Files</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {attachmentId?.map((x, i) => (
                                        <tr key={i}>
                                          <td>
                                            <Image width={100} height={100} src={x} />
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </table>
                              </Row>
                            </Card>
                          </Panel>
                        </Collapse>
                      </Card>
                    </Col>
                  </Row>
                </Modal>
                <Modal
                  title="Upload files"
                  centered
                  visible={showModalUpload}
                  closable={false}
                  width={1000}
                  footer={[
                    <>
                      <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <Button onClick={handleCloseshowRemarks} danger>
                          Close
                        </Button>
                      </div>
                    </>,
                  ]}
                >
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="table-responsive">
                        {" "}
                        <table className="table table-bordered">
                          <thead>
                            <tr>
                              <th className="text-center">File</th>
                              <th className="text-center">File Name</th>
                              <th className="text-center">-</th>
                            </tr>
                          </thead>
                          <tbody>
                            {uploadFields.map((field, index) => (
                              <tr id="addr0" key={index}>
                                <td>
                                  <input
                                    type="file"
                                    className="form-control"
                                    onChange={(event) => handleFileUpload(event, index)}
                                  />
                                </td>
                                <td>
                                  <input type="text" className="form-control" />
                                </td>
                                <td>
                                  <button
                                    type="button"
                                    className="btn btn-outline-danger btn-sm form-control"
                                    onClick={() => handleRemoveUploadField(index)}
                                  >
                                    Remove
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <div className="row">
                        <div className="col-lg-2">
                          <Button onClick={handleAddUploadField}>
                            Add Upload Field
                          </Button>
                        </div>
                        <div className="col-lg-2">
                          {uploadFields.length > 0 && (
                            <Button onClick={handleUpload}>Upload Files</Button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </Modal>
                <Modal
                  title="Things to do"
                  centered
                  width={1000}
                  visible={showmodalRemarks}
                  closable={false}
                  footer={[
                    <>
                      <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <Button onClick={handleCloseshowRemarks} danger>
                          Close
                        </Button>
                      </div>
                    </>,
                  ]}
                >
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col">Remarks</th>
                        <th scope="col">Date</th>
                        <th scope="col">Remarks By</th>
                      </tr>
                    </thead>
                    <tbody>
                      {remarksArray?.map((item, i) => (
                        <tr key={i}>
                          <th scope="row">{i + 1}</th>
                          <td>{item.remarks.toLocaleUpperCase()}</td>
                          <td>
                            {new Date(item.date).toLocaleDateString("en-US") +
                              " " +
                              new Date(item.date).toLocaleTimeString("en-US")}
                          </td>
                          <td>{item.deniedBy}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </Modal>
    </div>
  );
};

export default Admin;
